import { Card, ListGroup } from 'react-bootstrap';

const InfoAdherent = ({ adherent }) => {

    return (
        <Card>
            <Card.Header><h4>Adhérent</h4></Card.Header>
            <Card.Body>
                <ListGroup>
                    <ListGroup.Item><strong>Siret:</strong> {adherent.siret}</ListGroup.Item>
                    <ListGroup.Item><strong>Adhérent:</strong> {`${adherent.civilite}. ${adherent.prenom_adherent} ${adherent.nom_adherent}`}</ListGroup.Item>
                    <ListGroup.Item><strong>Entreprise:</strong> {adherent.nom_de_l_entreprise}</ListGroup.Item>
                    <ListGroup.Item><strong>Réseau:</strong> {adherent.reseau}</ListGroup.Item>
                </ListGroup>
            </Card.Body>
        </Card>
    );
}

export default InfoAdherent;
